import React from 'react';
import { ReactComponent as RotatingLinesSvg } from 'assets/icons/rotating-lines.svg';
import styles from './Loading.module.scss';

const Loading = () => {
  return <RotatingLinesSvg className={styles.loading} />
};

export default Loading;